
// Konfigurator
    
var $carousel1 = $('.sliderconfig1').flickity({
  prevNextButtons: false,
  pageDots: false,
  accessibility: false,
  draggable: false
});
// Flickity instance
var flkty = $carousel1.data('flickity');
// elements
var $cellButtonGroup = $('.slidernavbutton1');


// select cell on button click
$cellButtonGroup.on( 'click', '.selectslide', function() {
  var index = $(this).index();
  $carousel1.flickity( 'select', index );
});
    
    
var $carousel2 = $('.sliderconfig2').flickity({
  prevNextButtons: false,
  pageDots: false,
  accessibility: false,
  draggable: false
});
// Flickity instance
var flkty = $carousel2.data('flickity');
// elements
var $cellButtonGroup = $('.slidernavbutton2');


// select cell on button click
$cellButtonGroup.on( 'click', '.selectslide', function() {
  var index = $(this).index();
  $carousel2.flickity( 'select', index );
});

var $carousel3 = $('.sliderconfig3').flickity({
  prevNextButtons: false,
  pageDots: false,
  accessibility: false,
  draggable: false
});
// Flickity instance
var flkty = $carousel3.data('flickity');
// elements
var $cellButtonGroup = $('.slidernavbutton3');


// select cell on button click
$cellButtonGroup.on( 'click', '.selectslide', function() {
  var index = $(this).index();
  $carousel3.flickity( 'select', index );
});



// remove quantity option if foam is selected



$(document).ready(function() {

    if($("#inlay1").is(':checked')) { 
       $( "#sampleFormAuflage option[value=200]" ).wrap( "<span>" );
    } 

  $('#inlay1, #inlay2, #inlay3, #inlay4').change(function() {

    if($("#inlay1").is(':checked')) { 
       $( "#sampleFormAuflage option[value=200]" ).wrap( "<span>" );
    } 
    else { 
      if ( $( "#sampleFormAuflage option[value=200]" ).parent().is( "span" ) ){
    $( "#sampleFormAuflage option[value=200]" ).unwrap();
}
    }

  });

});





// Hide Extras


$(document).ready(function() {

  if($("#modell1").is(':checked')) { 
    $("#show-extra2").hide();
  }

  
  $('#modell1, #modell2, #modell3, #modell4, #modell5').click(function () {
    
    $( "#extra1, #extra2, #extra3, #extra7, #extra8, #extra9, #extra10" ).prop( "checked", false );
    
    $(".extraoption").show();

    if($("#modell1, #modell5").is(':checked')) { 
      $("#show-extra2").hide();
    }
    
    if($("#modell3").is(':checked')) { 
      $("#show-extra7").hide();
      $("#show-extra8").hide();
      $("#show-extra9").hide();
      $("#show-extra10").hide();
    }
    
    if($("#modell2, #modell4").is(':checked')) { 
      $("#show-extra2").hide();
      $("#show-extra7").hide();
      $("#show-extra8").hide();
      $("#show-extra9").hide();
      $("#show-extra10").hide();
    }

    
    });

});



// Show Size Warning


$(document).ready(function() {
  
   $("#size-warning-1, #size-warning-2, #size-warning-4").hide();


  
  $('#modell1, #modell2, #modell3, #modell4, #modell5').click(function () {
    
    $( "#size-warning-1, #size-warning-2, #size-warning-3, #size-warning-4" ).prop( "checked", false );
    
    $("#size-warning-1, #size-warning-2, #size-warning-3, #size-warning-4").hide();
    
    // Show Stülpboxen
    if($("#modell4").is(':checked')) { 
      $("#size-warning-1").show();
    }
    
    // Show Stülpboxen mit Kragen
    if($("#modell2").is(':checked')) { 
      $("#size-warning-2").show();
    }
    
    // Show Klappboxen
    if($("#modell1, #modell5").is(':checked')) { 
      $("#size-warning-3").show();
    }
    
    // Show Schiebeboxen
    if($("#modell3").is(':checked')) { 
      $("#size-warning-4").show();
    }

    
    
    });

});






jQuery(function($) {

  // Function which adds the 'animated' class to any '.animatable' in view
  var doAnimations = function() {
    
    // Calc current offset and get all animatables
    var offset = $(window).scrollTop() + $(window).height(),
        $animatables = $('.animatable');
    
    // Unbind scroll handler if we have no animatables
    if ($animatables.size() == 0) {
      $(window).off('scroll', doAnimations);
    }
    
    // Check all animatables and animate them if necessary
		$animatables.each(function(i) {
       var $animatable = $(this);
			if (($animatable.offset().top + $animatable.height() - 20) < offset) {
        $animatable.removeClass('animatable').addClass('animated');
			}
    });

	};
  
  // Hook doAnimations on scroll, and trigger a scroll
	$(window).on('scroll', doAnimations);
  $(window).trigger('scroll');
  
});




// FORMS    

jQuery(document).ready(function($) {

$('.form-custom-offer, .form-product, .form-sample, .form-contact').on('click', function(event) {
   
$("body").addClass('noscroll');
$("html").addClass('noscroll');
    
var $modal = $('#'+$(this).attr("class")),
    $modalform = $('.'+$(this).attr("class"));
    if ($(event.target).is($modalform)) {
      $(this).children('ul').toggleClass('is-visible');
    } else {
      $modalform.children('ul').removeClass('is-visible');
      $modal.addClass('is-visible');
    }

  });
            
   
  $('.icon-close').on('click', function(event) {  
    $('.loginbox-user-modal').removeClass('is-visible');
    $("body").removeClass('noscroll');
    $("html").removeClass('noscroll');
    $("#mappenselection").removeClass('active');
    $('#contactFormProdukttyp').removeClass('hide');    
    $("#contactFormProdukt").val("");
  });
  $(document).keyup(function(event) {
    if (event.which == '27') {
    $('.loginbox-user-modal').removeClass('is-visible');
    $("body").removeClass('noscroll');
    $("html").removeClass('noscroll');
    $("#mappenselection").removeClass('active');
    $('#contactFormProdukttyp').removeClass('hide');    
    $("#contactFormProdukt").val("");
    }
  });  
     
  
  
  $(".headerimg1").addClass('show');
  $(".textheader-inner").delay(1000).queue(function(){$(this).addClass('show')});
  $(".textheader").delay(3000).queue(function(){$(this).removeClass('show')});
  $('.intro').addClass('show');
  $('.arrowdown').addClass('show');

    $('[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if( target.length ) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 1000);
        }
    });

});    
    
// FORMS 

// Header

  $('.centerBtn').click(function(event){
      event.stopPropagation();
       $(".popover").toggleClass("active");
  });

  $('.centerBtn').click(function(event){
       var audio = document.getElementById("audioclick");
       audio.currentTime=0;
       audio.play();
  });





// Header

$(document).ready(function() {
    $('#hero-bg').addClass('show');
});

/**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2015, Codrops
 * http://www.codrops.com
 */
;(function(window) {

	'use strict';

	var support = { transitions: Modernizr.csstransitions },
		// transition end event name
		transEndEventNames = { 'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'oTransitionEnd', 'msTransition': 'MSTransitionEnd', 'transition': 'transitionend' },
		transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ],
		onEndTransition = function( el, callback ) {
			var onEndCallbackFn = function( ev ) {
				if( support.transitions ) {
					if( ev.target != this ) return;
					this.removeEventListener( transEndEventName, onEndCallbackFn );
				}
				if( callback && typeof callback === 'function' ) { callback.call(this); }
			};
			if( support.transitions ) {
				el.addEventListener( transEndEventName, onEndCallbackFn );
			}
			else {
				onEndCallbackFn();
			}
		};

	/**
	 * some helper functions
	 */
	
	function throttle(fn, delay) {
		var allowSample = true;

		return function(e) {
			if (allowSample) {
				allowSample = false;
				setTimeout(function() { allowSample = true; }, delay);
				fn(e);
			}
		};
	}

	function nextSibling(el) {
		var nextSibling = el.nextSibling;
		while(nextSibling && nextSibling.nodeType != 1) {
			nextSibling = nextSibling.nextSibling
		}
		return nextSibling;
	}

	function extend( a, b ) {
		for( var key in b ) { 
			if( b.hasOwnProperty( key ) ) {
				a[key] = b[key];
			}
		}
		return a;
	}

	/**
	 * GridFx obj
	 */
	function GridFx(el, options) {
		this.gridEl = el;
		this.options = extend( {}, this.options );
		extend( this.options, options );
		
		this.items = [].slice.call(this.gridEl.querySelectorAll('.grid__item'));
		this.previewEl = nextSibling(this.gridEl);
		this.isExpanded = false;
		this.isAnimating = false;
		this._init();
	}

	/**
	 * options
	 */
	GridFx.prototype.options = {
		pagemargin : 0,
		// x and y can have values from 0 to 1 (percentage). If negative then it means the alignment is left and/or top rather than right and/or bottom
		// so, as an example, if we want our large image to be positioned vertically on 25% of the screen and centered horizontally the values would be x:1,y:-0.25
		imgPosition : { x : 1, y : 1 },
		onInit : function(instance) { return false; },
		onResize : function(instance) { return false; },
		onOpenItem : function(instance, item) { return false; },
		onCloseItem : function(instance, item) { return false; },
		onExpand : function() { return false; }
	}

	GridFx.prototype._init = function() {
		// callback
		this.options.onInit(this);

		var self = this;
		// init masonry after all images are loaded
		imagesLoaded( this.gridEl, function() {
			// initialize masonry
			new Masonry(self.gridEl, {
				itemSelector: '.grid__item',
				isFitWidth : true
			});
			// show grid after all images (thumbs) are loaded
			classie.add(self.gridEl, 'grid--loaded');
			// init/bind events
		});
	};


	/**
	 * gets the window sizes
	 */
	GridFx.prototype._getWinSize = function() {
		return {
			width: document.documentElement.clientWidth,
			height: window.innerHeight
		};
	};

	window.GridFx = GridFx;

})(window);

	
 
(function ($) {

    var vph=0;
    function getViewportDimensions(){
        vph = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }
    getViewportDimensions();    
    //on resize/scroll
    $(window).on('resize orientationChanged', function(){
        getViewportDimensions();
    });            
    
    $.fn.inViewport = function (whenInView, whenNotInView) {                  
        return this.each(function () {
            var el = $(this),
                inviewalreadycalled = false,
                notinviewalreadycalled = false;                            
            //on resize/scroll
            $(window).on('resize orientationChanged scroll', function(){
                checkInView();
            });               
            function checkInView(){
                var rect = el[0].getBoundingClientRect(),
                    t = rect.top,
                    b = rect.bottom;
                if(t<vph && b>0){
                    if(!inviewalreadycalled){
                        whenInView.call(el);
                        inviewalreadycalled = true;
                        notinviewalreadycalled = false;
                    }
                } else {
                    if(!notinviewalreadycalled){
                        whenNotInView.call(el);
                        notinviewalreadycalled = true;
                        inviewalreadycalled = false;
                    }
                }
            }
            //initial check
            checkInView();                
        });
    }             
}(jQuery));

$('.step').inViewport(
    function(){$(this).addClass("in-view");},
    function(){$(this).removeClass("am-in-view");}
);

$('.slider').each( function( i, container ) {
  var $container = $( container );

  var $carousel = $container.find('.main-carousel').flickity({
    cellSelector: '.carousel-cell',
    setGallerySize: false,
    cellAlign: 'left',
    contain: true
  });
  // Flickity instance

});

jQuery(document).ready(function($){
	//update these values if you change these breakpoints in the style.css file (or _layout.scss if you use SASS)
	var MqM= 768,
		MqL = 1024;

	var faqsSections = $('.cd-faq-group'),
		faqTrigger = $('.cd-faq-trigger'),
		faqsContainer = $('.cd-faq-items'),
		faqsCategoriesContainer = $('.cd-faq-categories'),
		faqsCategories = faqsCategoriesContainer.find('a'),
		closeFaqsContainer = $('.cd-close-panel');
	
	//select a faq section 
	faqsCategories.on('click', function(event){
		event.preventDefault();
		var selectedHref = $(this).attr('href'),
			target= $(selectedHref);
		if( $(window).width() < MqM) {
			faqsContainer.scrollTop(0).addClass('slide-in').children('ul').removeClass('selected').end().children(selectedHref).addClass('selected');
			closeFaqsContainer.addClass('move-left');
			$('body').addClass('cd-overlay');
		} else {
	        $('body,html').animate({ 'scrollTop': target.offset().top}, 200); 
		}
	});

	//close faq lateral panel - mobile only
	$('body').bind('click touchstart', function(event){
		if( $(event.target).is('body.cd-overlay') || $(event.target).is('.cd-close-panel')) { 
			closePanel(event);
		}
	});
	faqsContainer.on('swiperight', function(event){
		closePanel(event);
	});

	//show faq content clicking on faqTrigger
	faqTrigger.on('click', function(event){
		event.preventDefault();
		$(this).next('.cd-faq-content').slideToggle(200).end().parent('li').toggleClass('content-visible');
	});

	//update category sidebar while scrolling
	$(window).on('scroll', function(){
		if ( $(window).width() > MqL ) {
			(!window.requestAnimationFrame) ? updateCategory() : window.requestAnimationFrame(updateCategory); 
		}
	});

	$(window).on('resize', function(){
		if($(window).width() <= MqL) {
			faqsCategoriesContainer.removeClass('is-fixed').css({
				'-moz-transform': 'translateY(0)',
			    '-webkit-transform': 'translateY(0)',
				'-ms-transform': 'translateY(0)',
				'-o-transform': 'translateY(0)',
				'transform': 'translateY(0)',
			});
		}	
		if( faqsCategoriesContainer.hasClass('is-fixed') ) {
			faqsCategoriesContainer.css({
				'left': faqsContainer.offset().left,
			});
		}
	});

	function closePanel(e) {
		e.preventDefault();
		faqsContainer.removeClass('slide-in').find('li').show();
		closeFaqsContainer.removeClass('move-left');
		$('body').removeClass('cd-overlay');
	}

	function updateCategory(){
		updateSelectedCategory();
	}


	function updateSelectedCategory() {
		faqsSections.each(function(){
			var actual = $(this),
				margin = parseInt($('.cd-faq-title').eq(1).css('marginTop').replace('px', '')),
				activeCategory = $('.cd-faq-categories a[href="#'+actual.attr('id')+'"]'),
				topSection = (activeCategory.parent('li').is(':first-child')) ? 0 : Math.round(actual.offset().top);
			
			if ( ( topSection - 20 <= $(window).scrollTop() ) && ( Math.round(actual.offset().top) + actual.height() + margin - 20 > $(window).scrollTop() ) ) {
				activeCategory.addClass('selected');
			}else {
				activeCategory.removeClass('selected');
			}
		});
	}
});

jQuery(document).ready(function($){
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
	var $L = 1200,
		$menu_navigation = $('#main-nav'),
		$hamburger_icon = $('#cd-hamburger-menu'),
		$lateral_cart = $('#cd-cart'),
		$shadow_layer = $('#cd-shadow-layer');

	//open lateral menu on mobile
	$hamburger_icon.on('click', function(event){
		event.preventDefault();
		//close cart panel (if it's open)
		$lateral_cart.removeClass('speed-in');
		toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
	});


	//close lateral cart or lateral menu
	$shadow_layer.on('click', function(){
		$shadow_layer.removeClass('is-visible');
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		if( $lateral_cart.hasClass('speed-in') ) {
			$lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$menu_navigation.removeClass('speed-in');
		} else {
			$menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$lateral_cart.removeClass('speed-in');
		}
	});

	//move #main-navigation inside header on laptop
	//insert #main-navigation after header on mobile
	move_navigation( $menu_navigation, $L);
	$(window).on('resize', function(){
		move_navigation( $menu_navigation, $L);
		
		if( $(window).width() >= $L && $menu_navigation.hasClass('speed-in')) {
			$menu_navigation.removeClass('speed-in');
			$shadow_layer.removeClass('is-visible');
			$('body').removeClass('overflow-hidden');
		}

	});
});

function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
	if( $lateral_panel.hasClass('speed-in') ) {
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		$lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.removeClass('overflow-hidden');
		});
		$background_layer.removeClass('is-visible');

	} else {
		$lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.addClass('overflow-hidden');
		});
		$background_layer.addClass('is-visible');
	}
}

function move_navigation( $navigation, $MQ) {
	if ( $(window).width() >= $MQ ) {
		$navigation.detach();
		$navigation.appendTo('header');
	} else {
		$navigation.detach();
		$navigation.insertAfter('header');
	}
}




// FORMS    

jQuery(document).ready(function($) {

$('.form-custom-offer, .form-product, .form-sample, .form-contact').on('click', function(event) {
   
$("body").addClass('noscroll');
$("html").addClass('noscroll');
    
var $modal = $('#'+$(this).attr("class")),
    $modalform = $('.'+$(this).attr("class"));
    if ($(event.target).is($modalform)) {
      $(this).children('ul').toggleClass('is-visible');
    } else {
      $modalform.children('ul').removeClass('is-visible');
      $modal.addClass('is-visible');
    }

  });
            
   
  $('.icon-close').on('click', function(event) {  
    $('.loginbox-user-modal').removeClass('is-visible');
    $("body").removeClass('noscroll');
    $("html").removeClass('noscroll');
    $("#mappenselection").removeClass('active');
    $('#contactFormProdukttyp').removeClass('hide');    
    $("#contactFormProdukt").val("");
  });
  $(document).keyup(function(event) {
    if (event.which == '27') {
    $('.loginbox-user-modal').removeClass('is-visible');
    $("body").removeClass('noscroll');
    $("html").removeClass('noscroll');
    $("#mappenselection").removeClass('active');
    $('#contactFormProdukttyp').removeClass('hide');    
    $("#contactFormProdukt").val("");
    }
  });  
    
    
    

});    
    
// FORMS  

// HERO TYPO  

jQuery(document).ready(function($){
	//this is used for the video effect only
	if( $('.cd-bg-video-wrapper').length > 0 ) {
		var videoWrapper = $('.cd-bg-video-wrapper'),
			mq = window.getComputedStyle(document.querySelector('.cd-bg-video-wrapper'), '::after').getPropertyValue('content').replace(/"/g, "").replace(/'/g, "");
		if( mq == 'desktop' ) {
			// we are not on a mobile device 
			var	videoUrl = videoWrapper.data('video'),
				video = $('<video loop><source src="'+videoUrl+'.mp4" type="video/mp4" /><source src="'+videoUrl+'.webm" type="video/webm" /></video>');
			video.appendTo(videoWrapper);
			video.get(0).play();
		}
	}
});

// HERO TYPO



// Design Lightbox
jQuery(document).ready(function($){
  $("#feinleinen").click(function(){$("#open-feinleinen").addClass("md-show");});
  $("#druckmotiv").click(function(){$("#open-druckmotiv").addClass("md-show");});
  $("#lederfaser").click(function(){$("#open-lederfaser").addClass("md-show");});
  $("#metallic").click(function(){$("#open-metallic").addClass("md-show");});
  $("#hotfoil").click(function(){$("#open-hotfoil").addClass("md-show");});
  $("#blind").click(function(){$("#open-blind").addClass("md-show");});
  $("#colorfoil").click(function(){$("#open-colorfoil").addClass("md-show");});
  $("#uvlack").click(function(){$("#open-uvlack").addClass("md-show");});
  $("#eckfach").click(function(){$("#open-eckfach").addClass("md-show");});
  $("#va").click(function(){$("#open-va").addClass("md-show");});
  $("#dreilaschen").click(function(){$("#open-dreilaschen").addClass("md-show");});
  $("#schaumeinlage").click(function(){$("#open-schaumeinlage").addClass("md-show");});
  $("#stiftehalterung").click(function(){$("#open-stiftehalterung").addClass("md-show");});
  $("#metallschutzecken").click(function(){$("#open-metallschutzecken").addClass("md-show");});
  $("#gummizugverschluss").click(function(){$("#open-gummizugverschluss").addClass("md-show");});
  $("#magnetverschluss").click(function(){$("#open-magnetverschluss").addClass("md-show");});
  $("#visitenkartenfach").click(function(){$("#open-visitenkartenfach").addClass("md-show");});
  $("#usb").click(function(){$("#open-usb").addClass("md-show");});
  $("#kombimechanik").click(function(){$("#open-kombimechanik").addClass("md-show");});
  $("#hebelmechanik").click(function(){$("#open-hebelmechanik").addClass("md-show");});
  $("#klemmmechanik").click(function(){$("#open-klemmmechanik").addClass("md-show");});
  $("#schnellheftung").click(function(){$("#open-schnellheftung").addClass("md-show");});
  $("#buchschrauben").click(function(){$("#open-buchschrauben").addClass("md-show");});
  $("#klemmschiene").click(function(){$("#open-klemmschiene").addClass("md-show");});
  
  
  
  
  $(".cd-item").click(function(){  
    $("body").addClass('noscroll');
    });  
  $('.content-close, .m-content').click(function(){
    $("body").removeClass('noscroll');
    $(".m-content").removeClass("md-show");
  });
});



jQuery(document).ready(function($){
$('a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if( target.length ) {
        event.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top - 100
        }, 1000);
    }
});
});  



$(document).ready(function() {
  
  $('#uspBtn').click(function(){
    $("#uspInfo").toggleClass("active");
  });
  
  
});

$(document).ready(function() {
  
  $('#td').click(function(){
		$(this).next('#td2').slideToggle(700).end().toggleClass("active", 500);
  });
  
  
});

$(document).ready(function() {
  
  $('#td3').click(function(){
		$(this).next('#td4').slideToggle(700).end().toggleClass("active", 500);
  });
  
  
});

$(document).ready(function() {
  
  $('#td5').click(function(){
		$(this).next('#td6').slideToggle(700).end().toggleClass("active", 500);
  });
  
  
});




/**
 * animOnScroll.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
;( function( window ) {
	
	'use strict';
	
	var docElem = window.document.documentElement;

	function getViewportH() {
		var client = docElem['clientHeight'],
			inner = window['innerHeight'];
		
		if( client < inner )
			return inner;
		else
			return client;
	}

	function scrollY() {
		return window.pageYOffset || docElem.scrollTop;
	}

	// http://stackoverflow.com/a/5598797/989439
	function getOffset( el ) {
		var offsetTop = 0, offsetLeft = 0;
		do {
			if ( !isNaN( el.offsetTop ) ) {
				offsetTop += el.offsetTop;
			}
			if ( !isNaN( el.offsetLeft ) ) {
				offsetLeft += el.offsetLeft;
			}
		} while( el = el.offsetParent )

		return {
			top : offsetTop,
			left : offsetLeft
		}
	}

	function inViewport( el, h ) {
		var elH = el.offsetHeight,
			scrolled = scrollY(),
			viewed = scrolled + getViewportH(),
			elTop = getOffset(el).top,
			elBottom = elTop + elH,
			// if 0, the element is considered in the viewport as soon as it enters.
			// if 1, the element is considered in the viewport only when it's fully inside
			// value in percentage (1 >= h >= 0)
			h = h || 0;

		return (elTop + elH * h) <= viewed && (elBottom - elH * h) >= scrolled;
	}

	function extend( a, b ) {
		for( var key in b ) { 
			if( b.hasOwnProperty( key ) ) {
				a[key] = b[key];
			}
		}
		return a;
	}

	function AnimOnScroll( el, options ) {	
		this.el = el;
		this.options = extend( this.defaults, options );
		this._init();
	}

	AnimOnScroll.prototype = {
		defaults : {
			// Minimum and a maximum duration of the animation (random value is chosen)
			minDuration : 0,
			maxDuration : 0,
			// The viewportFactor defines how much of the appearing item has to be visible in order to trigger the animation
			// if we'd use a value of 0, this would mean that it would add the animation class as soon as the item is in the viewport. 
			// If we were to use the value of 1, the animation would only be triggered when we see all of the item in the viewport (100% of it)
			viewportFactor : 0
		},
		_init : function() {
			this.items = Array.prototype.slice.call( document.querySelectorAll( '#' + this.el.id + ' > li' ) );
			this.itemsCount = this.items.length;
			this.itemsRenderedCount = 0;
			this.didScroll = false;

			var self = this;

			imagesLoaded( this.el, function() {
				
				// initialize masonry
				new Masonry( self.el, {
					itemSelector: 'li',
					transitionDuration : 0
				} );
				
				if( Modernizr.cssanimations ) {
					// the items already shown...
					self.items.forEach( function( el, i ) {
						if( inViewport( el ) ) {
							self._checkTotalRendered();
							classie.add( el, 'shown' );
						}
					} );

					// animate on scroll the items inside the viewport
					window.addEventListener( 'scroll', function() {
						self._onScrollFn();
					}, false );
					window.addEventListener( 'resize', function() {
						self._resizeHandler();
					}, false );
				}

			});
		},
		_onScrollFn : function() {
			var self = this;
			if( !this.didScroll ) {
				this.didScroll = true;
				setTimeout( function() { self._scrollPage(); }, 60 );
			}
		},
		_scrollPage : function() {
			var self = this;
			this.items.forEach( function( el, i ) {
				if( !classie.has( el, 'shown' ) && !classie.has( el, 'animate' ) && inViewport( el, self.options.viewportFactor ) ) {
					setTimeout( function() {
						var perspY = scrollY() + getViewportH() / 2;
						self.el.style.WebkitPerspectiveOrigin = '50% ' + perspY + 'px';
						self.el.style.MozPerspectiveOrigin = '50% ' + perspY + 'px';
						self.el.style.perspectiveOrigin = '50% ' + perspY + 'px';

						self._checkTotalRendered();

						if( self.options.minDuration && self.options.maxDuration ) {
							var randDuration = ( Math.random() * ( self.options.maxDuration - self.options.minDuration ) + self.options.minDuration ) + 's';
							el.style.WebkitAnimationDuration = randDuration;
							el.style.MozAnimationDuration = randDuration;
							el.style.animationDuration = randDuration;
						}
						
						classie.add( el, 'animate' );
					}, 25 );
				}
			});
			this.didScroll = false;
		},
		_resizeHandler : function() {
			var self = this;
			function delayed() {
				self._scrollPage();
				self.resizeTimeout = null;
			}
			if ( this.resizeTimeout ) {
				clearTimeout( this.resizeTimeout );
			}
			this.resizeTimeout = setTimeout( delayed, 1000 );
		},
		_checkTotalRendered : function() {
			++this.itemsRenderedCount;
			if( this.itemsRenderedCount === this.itemsCount ) {
				window.removeEventListener( 'scroll', this._onScrollFn );
			}
		}
	}

	// add to global namespace
	window.AnimOnScroll = AnimOnScroll;

} )( window );


// Design Lightbox
jQuery(document).ready(function($){
  $("#packaging1").click(function(){$("#open-packaging1").addClass("md-show");});
  $("#packaging2").click(function(){$("#open-packaging2").addClass("md-show");});
  $("#packaging3").click(function(){$("#open-packaging3").addClass("md-show");});
  $("#packaging4").click(function(){$("#open-packaging4").addClass("md-show");});
  $("#packaging5").click(function(){$("#open-packaging5").addClass("md-show");});
  $("#packaging6").click(function(){$("#open-packaging6").addClass("md-show");});
  $("#packaging7").click(function(){$("#open-packaging7").addClass("md-show");});
  $("#packaging8").click(function(){$("#open-packaging8").addClass("md-show");});
  $("#packaging13").click(function(){$("#open-packaging13").addClass("md-show");});
  $("#packaging9").click(function(){$("#open-packaging9").addClass("md-show");});
  $("#packaging11").click(function(){$("#open-packaging11").addClass("md-show");});
  $("#packaging10").click(function(){$("#open-packaging10").addClass("md-show");});
  $("#packaging12").click(function(){$("#open-packaging12").addClass("md-show");});
  $("#packaging17").click(function(){$("#open-packaging17").addClass("md-show");});
  $("#packaging22").click(function(){$("#open-packaging22").addClass("md-show");});
  $("#packaging14").click(function(){$("#open-packaging14").addClass("md-show");});
  $("#packaging16").click(function(){$("#open-packaging16").addClass("md-show");});
  $("#packaging15").click(function(){$("#open-packaging15").addClass("md-show");});
  $("#packaging20").click(function(){$("#open-packaging20").addClass("md-show");});
  $("#packaging19").click(function(){$("#open-packaging19").addClass("md-show");});
  $("#packaging21").click(function(){$("#open-packaging21").addClass("md-show");});
  $("#packaging18").click(function(){$("#open-packaging18").addClass("md-show");});
  $("#packaging23").click(function(){$("#open-packaging23").addClass("md-show");});
  $("#packaging24").click(function(){$("#open-packaging24").addClass("md-show");});
  $("#packaging25").click(function(){$("#open-packaging25").addClass("md-show");});
  $("#packaging26").click(function(){$("#open-packaging26").addClass("md-show");});
  $("#packaging27").click(function(){$("#open-packaging27").addClass("md-show");});
  $("#packaging28").click(function(){$("#open-packaging28").addClass("md-show");});
  $("#packaging29").click(function(){$("#open-packaging29").addClass("md-show");});
  $("#packaging30").click(function(){$("#open-packaging30").addClass("md-show");});
  $("#packaging31").click(function(){$("#open-packaging31").addClass("md-show");});
  $("#packaging32").click(function(){$("#open-packaging32").addClass("md-show");});
  $("#packaging33").click(function(){$("#open-packaging33").addClass("md-show");});
  $("#packaging34").click(function(){$("#open-packaging34").addClass("md-show");});
  $("#packaging35").click(function(){$("#open-packaging35").addClass("md-show");});
  $("#packaging36").click(function(){$("#open-packaging36").addClass("md-show");});
  $("#packaging37").click(function(){$("#open-packaging37").addClass("md-show");});
  $("#packaging38").click(function(){$("#open-packaging38").addClass("md-show");});
  $("#packaging39").click(function(){$("#open-packaging39").addClass("md-show");});
  $("#packaging40").click(function(){$("#open-packaging40").addClass("md-show");});
  $("#packaging41").click(function(){$("#open-packaging41").addClass("md-show");});
  $("#packaging42").click(function(){$("#open-packaging42").addClass("md-show");});
  $("#packaging43").click(function(){$("#open-packaging43").addClass("md-show");});
  $("#packaging44").click(function(){$("#open-packaging44").addClass("md-show");});
  $("#packaging45").click(function(){$("#open-packaging45").addClass("md-show");});
  $("#packaging46").click(function(){$("#open-packaging46").addClass("md-show");});
 
  $("#newgriditem1").click(function(){$("#open-newgriditem1").addClass("md-show");});
  $("#newgriditem2").click(function(){$("#open-newgriditem2").addClass("md-show");});
  $("#newgriditem3").click(function(){$("#open-newgriditem3").addClass("md-show");});
  $("#newgriditem4").click(function(){$("#open-newgriditem4").addClass("md-show");});
  $("#newgriditem5").click(function(){$("#open-newgriditem5").addClass("md-show");});
  $("#newgriditem6").click(function(){$("#open-newgriditem6").addClass("md-show");});

  
  
  $("#designtest1").click(function(){$("#open-designtest1").addClass("md-show");});
  $("#designtest2").click(function(){$("#open-designtest2").addClass("md-show");});
  $("#designtest3").click(function(){$("#open-designtest3").addClass("md-show");});
  $("#designtest4").click(function(){$("#open-designtest4").addClass("md-show");});
  $("#designtest5").click(function(){$("#open-designtest5").addClass("md-show");});
  $("#designtest6").click(function(){$("#open-designtest6").addClass("md-show");});
  
  
  $(".grid__item").click(function(){  
    $("body").addClass('noscroll');
    });  
  $('.content-close, .m-content').click(function(){
    $("body").removeClass('noscroll');
    $(".m-content").removeClass("md-show");
  });
});

jQuery(document).ready(function($){
	var itemInfoWrapper = $('.cd-single-item1');
	
	itemInfoWrapper.each(function(){
		var container = $(this),
			// create slider pagination
			sliderPagination = createSliderPagination(container);
		
		//update slider navigation visibility
		updateNavigation(container, container.find('.cd-slider1 li').eq(0));

		container.find('.cd-slider1').on('click', function(event){
			//enlarge slider images 
			if( !container.hasClass('cd-slider-active1') && $(event.target).is('.cd-slider1')) {
				itemInfoWrapper.removeClass('cd-slider-active1');
				container.addClass('cd-slider-active1').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
					$('body,html').animate({'scrollTop':container.offset().top-60}, 200);
				});
			}
		});

		container.find('.cd-close1').on('click', function(){
			//shrink slider images 
			container.removeClass('cd-slider-active1');
		});

		//update visible slide
		container.find('.cd-next').on('click', function(){
			nextSlide(container, sliderPagination);
		});

		container.find('.cd-prev').on('click', function(){
			prevSlide(container, sliderPagination);
		});

		container.find('.cd-slider1').on('swipeleft', function(){
			var wrapper = $(this),
				bool = enableSwipe(container);
			if(!wrapper.find('.selected').is(':last-child') && bool) {nextSlide(container, sliderPagination);}
		});

		container.find('.cd-slider1').on('swiperight', function(){
			var wrapper = $(this),
				bool = enableSwipe(container);
			if(!wrapper.find('.selected').is(':first-child') && bool) {prevSlide(container, sliderPagination);}
		});

		sliderPagination.on('click', function(){
			var selectedDot = $(this);
			if(!selectedDot.hasClass('selected')) {
				var selectedPosition = selectedDot.index(),
					activePosition = container.find('.cd-slider1 .selected').index();
				if( activePosition < selectedPosition) {
					nextSlide(container, sliderPagination, selectedPosition);
				} else {
					prevSlide(container, sliderPagination, selectedPosition);
				}
			}
		});
	});	
		
	//keyboard slider navigation
	$(document).keyup(function(event){
		if(event.which=='37' && $('.cd-slider-active1').length > 0 && !$('.cd-slider-active1 .cd-slider1 .selected').is(':first-child')) {
			prevSlide($('.cd-slider-active1'), $('.cd-slider-active1').find('.cd-slider-pagination1 li'));
		} else if( event.which=='39' && $('.cd-slider-active1').length && !$('.cd-slider-active1 .cd-slider1 .selected').is(':last-child')) {
			nextSlide($('.cd-slider-active1'), $('.cd-slider-active1').find('.cd-slider-pagination1 li'));
		} else if(event.which=='27') {
			itemInfoWrapper.removeClass('cd-slider-active');
		}
	});

	function createSliderPagination($container){
		var wrapper = $('<ul class="cd-slider-pagination1"></ul>').insertAfter($container.find('.cd-slider-navigation1'));
		$container.find('.cd-slider1 li').each(function(index){
			var dotWrapper = (index == 0) ? $('<li class="selected"></li>') : $('<li></li>'),
				dot = $('<a href="#0"></a>').appendTo(dotWrapper);
			dotWrapper.appendTo(wrapper);
			dot.text(index+1);
		});
		return wrapper.children('li');
	}

	function nextSlide($container, $pagination, $n){
		var visibleSlide = $container.find('.cd-slider1 .selected'),
			navigationDot = $container.find('.cd-slider-pagination1 .selected');
		if(typeof $n === 'undefined') $n = visibleSlide.index() + 1;
		visibleSlide.removeClass('selected');
		$container.find('.cd-slider1 li').eq($n).addClass('selected').prevAll().addClass('move-left');
		navigationDot.removeClass('selected')
		$pagination.eq($n).addClass('selected');
		updateNavigation($container, $container.find('.cd-slider1 li').eq($n));
	}

	function prevSlide($container, $pagination, $n){
		var visibleSlide = $container.find('.cd-slider1 .selected'),
			navigationDot = $container.find('.cd-slider-pagination1 .selected');
		if(typeof $n === 'undefined') $n = visibleSlide.index() - 1;
		visibleSlide.removeClass('selected')
		$container.find('.cd-slider1 li').eq($n).addClass('selected').removeClass('move-left').nextAll().removeClass('move-left');
		navigationDot.removeClass('selected');
		$pagination.eq($n).addClass('selected');
		updateNavigation($container, $container.find('.cd-slider1 li').eq($n));
	}

	function updateNavigation($container, $active) {
		$container.find('.cd-prev').toggleClass('inactive', $active.is(':first-child'));
		$container.find('.cd-next').toggleClass('inactive', $active.is(':last-child'));
	}

	function enableSwipe($container) {
		var mq = window.getComputedStyle(document.querySelector('.cd-slider1'), '::before').getPropertyValue('content').replace(/"/g, "").replace(/'/g, "");
		return ( mq=='mobile' || $container.hasClass('cd-slider-active1'));
	}
});

$(document).ready(function() {
    
    /* Every time the window is scrolled ... */
    $(window).scroll( function(){
    
        /* Check the location of each desired element */
        $('.hideme').each( function(i){
            
            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            
            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window = bottom_of_object ){
                
                $(this).animate({'opacity':'1'},1000);
                    
            }
            
        }); 
    
    });
    
});

$(document).ready(function() {
    
    /* Every time the window is scrolled ... */
    $(window).scroll( function(){
    
        /* Check the location of each desired element */
        $('.hideme1').each( function(i){
            
            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            
            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){
                
                $(this).animate({'opacity':'1'},1000);
                    
            }
            
        }); 
    
    });
    
});

// swatch

$(document).ready(function(){  
 $( "input[name='inspimaterial']" ).change(function(){
$("#inspicolor").css('background-image','url('+ $(this).data("image")+')');
});
});

$('.swatch').flickity({
  // options
  cellSelector: '.swatch-element',
  freeScroll: true,
  contain: true,
  groupCells: '80%',
  pageDots: false
});


  //  slider without caption
  $('.heroslider').each(function(i, container) {
    var $container = $(container);

    var $carousel = $container.find('.main-carousel').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: false,
      lazyLoad: 2,
      imagesLoaded: true,
      autoPlay: 2000,
      cellAlign: 'left',
      pageDots: true,
      contain: true
    });
    
  });



$('.blog-teaser-container').flickity({
  cellSelector: '.blog-teaser-element',
  contain: true,
  cellAlign: 'left',
  wrapAround: true,
  adaptiveHeight: true,
  pageDots: false
});


Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};


// christmas popup



$(document).ready(function() {
  $('.pop-up-c').addClass('show');

  $('.pop-up-c').on('click', function(event) {
    $(this).removeClass('show');
  });

});


// resize slider

jQuery(window).load( function() {
    window.dispatchEvent(new Event('resize'));
});  
  


// scroll top header menu click
$(document).ready(function() {
$("#cd-hamburger-menu").click(function() {
window.scrollTo({ top: 0, behavior: 'smooth' });
});
});


